import {
    Grid,
    List,
    ListItem,
    Skeleton,
    Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";


const FacilityPlansCmp = (props: any) => {

    return (
        <>
            <List>
                <ListItem>
                    <Grid container spacing={0}>
                        <Grid xs={12} sm={12} md={2} lg={2} textAlign={"right"}>
                            {props.cardImage ? (
                                <img
                                    className="activePlansCardImg"
                                    src={`data:image/png;base64,${props.cardImage}`}
                                    alt=""
                                />
                            ) : (
                                <Skeleton
                                    variant="rectangular"
                                    width={140}
                                    height={75}
                                    animation={false}
                                    sx={{
                                        // marginLeft: "0.5rem",
                                        borderRadius: "5px",
                                    }}
                                ></Skeleton>
                            )}
                        </Grid>
                        <Grid container spacing={0} xs={9} sm={12} md={9} lg={9}>
                            <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid
                                    container
                                    alignItems={"center"}
                                    justifyContent={{
                                        xs: "center",
                                        sm: "center",
                                        md: "center",
                                        lg: "space-between",
                                    }}
                                >
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Typography
                                            color={"#1D4A87"}
                                            textAlign={{ xs: "center", lg: "start" }}
                                            fontWeight={"bold"}
                                            marginY={{
                                                xs: "1rem",
                                                sm: "1rem",
                                                md: "1rem",
                                                lg: "0",
                                                xl: "0",
                                            }}
                                            fontSize={"18px"}

                                        >
                                            {props.title}{props.isActive !== true ? <span style={{ color: "#EE9D01", fontWeight: 'normal' }}> (غیرفعال) </span> : ""}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid
                                container
                                xs={12}
                                columns={{ xs: 4, sm: 8, md: 12 }}
                                style={{ alignSelf: 'center' }}
                            // spacing={0}
                            // justifyContent={{
                            //     xs: "center",
                            //     sm: "center",
                            //     md: "center",
                            //     lg: "space-between",
                            // }}
                            // alignItems={"center"}
                            >

                                <Grid
                                    item
                                    xs={6}
                                    md={3}
                                    sm={6}
                                    borderLeft={{ lg: "1px solid #c1c7cb", md: "1px solid #c1c7cb" }}
                                    borderBottom={{ xs: "1px solid #c1c7cb", md: "none" }}
                                    paddingX={".5rem"}
                                    paddingY={{
                                        xs: "1rem",
                                        sm: "1rem",
                                        md: "1rem",
                                        lg: "0",
                                        xl: "0",
                                    }}
                                // style={{ textAlign: '' }}
                                // // xs={12}
                                // sm={12}
                                // md={6}
                                // lg={4}
                                >
                                    <Typography textAlign={{ sm: "center", md: "justify", xs: "center" }}>
                                        تعداد تسهیلات اعطا شده: <b style={{ fontWeight: 'bold' }}>{props.count}</b>
                                    </Typography>
                                </Grid>
                                <Grid
                                    item
                                    xs={4}
                                    md={4}
                                    sm={6}
                                    //className="divisionConfacilityCardFinancial"
                                    borderLeft={{ lg: "1px solid #c1c7cb", md: "1px solid #c1c7cb" }}
                                    borderBottom={{ xs: "1px solid #c1c7cb", md: "none" }}
                                    paddingX={{ lg: ".5rem", md: "0" }}
                                    paddingY={{
                                        xs: "1rem",
                                        sm: "1rem",
                                        md: "1rem",
                                        lg: "0",
                                        xl: "0",
                                    }}
                                // // xs={12}
                                // sm={12}
                                // md={6}
                                // lg={5}
                                >
                                    <Typography textAlign={"center"} >
                                        مبلغ کل تسهیلات اعطا شده:{" "}
                                        <b style={{ fontWeight: 'bold' }}>{props.totalAmountRial?.toLocaleString("fa")} ریال</b>
                                    </Typography>
                                </Grid>
                                <Grid
                                    item
                                    xs={3}
                                    md={3}
                                    sm={6}
                                    // className="divisionConfacilityCardFinancial"
                                    paddingX={".5rem"}
                                    paddingY={{
                                        xs: "1rem",
                                        sm: "1rem",
                                        md: "1rem",
                                        lg: "0",
                                        xl: "0",
                                    }}
                                // // xs={12}
                                // sm={12}
                                // md={6}
                                // lg={4}
                                >
                                    <Typography textAlign={"center"} >
                                        تاریخ انقضا:{" "}
                                        <b style={{ fontWeight: 'bold' }}>{props.expirationDatePersian}</b>
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </ListItem>
            </List>
        </>
    );
};

export default FacilityPlansCmp;
